var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"white",attrs:{"src":_vm.apiURL + 'organism/' + _vm.id + '/picture',"contain":"","height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }